import type { AppState } from 'state/state.model';

export function getSecondaryMarketTradeStatus(state: AppState, quoteId: string) {
  return state.secondaryMarket.realtimeQuote.trade[quoteId]?.status;
}
